export default __webpack_public_path__ + "static/media/PAFI_Audit Report 2023.6bad6dd7.pdf";